import * as React from 'react';

type MonitoringProps = {
  appKey: string;
  beaconUrl: string;
};

// AppDynamics EUM app keys are alphanumeric/hyphenated (e.g. "AD-AAB-ZALW-Z"); reject anything else
// to prevent breaking out of the inline script's string literal.
const APP_KEY_PATTERN = /^[A-Za-z0-9-]{5,64}$/;

function isHttpsUrl(value: string): boolean {
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
}

export const Monitoring: React.FC<MonitoringProps> = ({ appKey, beaconUrl }) => {
  if (!APP_KEY_PATTERN.test(appKey) || !isHttpsUrl(beaconUrl)) {
    return null;
  }

  return (
    <>
      <script
        charSet="UTF-8"
        dangerouslySetInnerHTML={{
          __html: `window['adrum-start-time'] = new Date().getTime();
(function(config){
    config.appKey = ${JSON.stringify(appKey)};
    config.adrumExtUrlHttp = '/js/adrum/';
    config.adrumExtUrlHttps = '/js/adrum/';
    config.beaconUrlHttps = ${JSON.stringify(beaconUrl)};
    config.xd = {enable : false};
})(window['adrum-config'] || (window['adrum-config'] = {}));`,
        }}
      ></script>
      {/* Rendered as a real script tag (part of the SSR HTML) instead of via document.write,
          so it still loads in document order without the injection risk of document.write(unescape(...)). */}
      <script src="/js/adrum/adrum-4.3.2.0.js" type="text/javascript" charSet="UTF-8"></script>
    </>
  );
};
